import type { JobSalary } from "@lossdog/job-watchlists";
import { useSignals } from "@preact/signals-react/runtime";
import { cx } from "class-variance-authority";

import { NumberUtils } from "@/util/number.utils";

interface Props {
  jobSalary: JobSalary;
  propKey?: "netChangeOneYear" | "netChangeThreeYear" | "netChangeFiveYear";
}
export const JobSalaryYearlyChangesValue = ({ jobSalary, propKey = "netChangeOneYear" }: Props) => {
  useSignals();
  return (
    <span className={cx("text-right text-neutral-200", "text-white")}>
      {!!jobSalary[propKey].value && "+"}
      {NumberUtils.formatAsUSCurrency(jobSalary[propKey].value, { useAbsoluteValue: true, hideCurrency: true })}
    </span>
  );
};
